import { render } from "./RocketBig.vue?vue&type=template&id=be85cb24"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/RocketBig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be85cb24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be85cb24', __exports__)) {
    api.reload('be85cb24', __exports__)
  }
  
  module.hot.accept("./RocketBig.vue?vue&type=template&id=be85cb24", () => {
    api.rerender('be85cb24', render)
  })

}


export default __exports__